import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]

import { ElementColor } from "@/utils/const";


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorPalette',
  props: {
    colors: {},
    isSimple: { type: Boolean },
    selected_color: {}
  },
  emits: ["setColor"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color, k) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
      (!_ctx.isSimple || color.simple)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(["material-icons align-middle text-slate-500 w-6 cursor-pointer", [_ctx.selected_color === color.value ? 'text-3xl mr-1' : '', _ctx.isSimple && color.bp ? `hidden md:inline-block` : '']]),
            style: _normalizeStyle(`color:${color.value}`),
            onClick: ($event: any) => (emit('setColor', color.value))
          }, "square", 14, _hoisted_1))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}
}

})